import "./index.css";

export const AgenciasPreimpresos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Agencias preimpresos</h1>
      </div>
    </div>
  );
};
